/**
 * What: Single shared error/status banner with an optional action.
 * Transport / data-flow: Pure presentation; callers own copy, state, and handlers.
 *
 * Replaces hand-rolled s-banner + paragraph + button stacks repeated across
 * index pages (PreparedSetupsIndexStates, ...).
 */
import type { ComponentProps, ReactNode } from 'react'

type NoticeBannerProps = {
  tone: ComponentProps<'s-banner'>['tone']
  heading: string
  children?: ReactNode
  action?: ReactNode
}

/** Banner with a real heading (mirrored to light DOM for tests) and one action slot. */
export function NoticeBanner({ tone, heading, children, action }: NoticeBannerProps) {
  return (
    <s-banner heading={heading} tone={tone}>
      <s-stack direction="block" gap="small-200">
        {children}
        {action}
      </s-stack>
    </s-banner>
  )
}
